import { createSlice, createAction } from '@reduxjs/toolkit';
import {
  ICreateCredentialPayload,
  ICredential,
  IUpdateCredentialPayload
} from 'shared/interfaces/ctrlCredentials.interface';
import { IState } from 'shared/interfaces/state.interface';

export const getCredential = createAction('credentials/getCredential');

export const createCredential = createAction(
  'credentials/createCredential',
  (payload: ICreateCredentialPayload) => ({
    payload
  })
);

export const updateCredential = createAction(
  'credentials/updateCredential',
  (payload: IUpdateCredentialPayload) => ({ payload })
);

export const deleteCredential = createAction('credentials/deleteCredential');

interface CredentialsState {
  credential: ICredential;
  isLoading: boolean;
  error: string | null;
}

const initialState: CredentialsState = {
  credential: {} as ICredential,
  isLoading: false,
  error: null
};

const credentialsSlice = createSlice({
  name: 'credentials',
  initialState,
  reducers: {
    getCredentialData: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    setCredentialData: (state, { payload }) => {
      state.credential = payload;
      state.isLoading = false;
      state.error = null;
    },
    addCredential: (state, { payload }) => {
      state.credential = payload;
      state.isLoading = false;
      state.error = null;
    },
    updateCredentialInState: (state, { payload }) => {
      state.credential = { ...state.credential, ...payload };
      state.isLoading = false;
      state.error = null;
    },
    removeCredential: (state) => {
      state.credential = {} as ICredential;
      state.isLoading = false;
      state.error = null;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
      state.isLoading = false;
    }
  }
});

export const {
  getCredentialData,
  setCredentialData,
  addCredential,
  updateCredentialInState,
  removeCredential,
  setLoading,
  setError
} = credentialsSlice.actions;

export const { reducer } = credentialsSlice;

export const getCredentialSelector = (state: IState) =>
  state?.ctrlCredentials?.credential || ({} as ICredential);

export const getCredentialsLoadingSelector = (state: IState) =>
  state?.ctrlCredentials?.isLoading || false;

export const getCredentialsErrorSelector = (state: IState) =>
  state?.ctrlCredentials?.error || null;
